import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TResetSearchingResults, EResetSearchingResultsActionType } from './types';

export const resetSearchingResults: () => TResetSearchingResults =
  actionGenerator<EResetSearchingResultsActionType.Reset>(EResetSearchingResultsActionType.Reset);
